import { usePostPropertyVehicleMutation } from "web_myplann/Api/Portfolio/Mutations/usePostPropertyVehicleMutation";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { CAR_FORM_DEFAULT_VALUES } from "web_myplann/Portfolio/Forms/CarForm/carFormDefaults";
import { getCarFormSchema } from "web_myplann/Portfolio/Forms/CarForm/carFormSchema";
import { useCreatePortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useCreatePortfolioForm";

export const useCreateCarForm = () => {
	const { t } = useResource();
	const { mutate, isPending } = usePostPropertyVehicleMutation();

	const { form, onSubmit } = useCreatePortfolioForm({
		schema: getCarFormSchema(t),
		defaultValues: CAR_FORM_DEFAULT_VALUES,
		mutate,
		successRoute: Routing.Portfolio.PortfolioAddCarSuccess.path(),
	});

	return { form, onSubmit, isPending };
};
